<template>
  <div>
    <div class="d-flex justify-content-between">
      <div>
        <div class="section-title">{{ $t("ticketpriceconfiguration") }}</div>
        <div class="section-subTitle my-2">
          {{ $t("ticket_price_config_dash_msg") }}
        </div>
      </div>
      <div>
        <b-button
          variant="default"
          to="add-ticket-price-configuration"
          class="btn-blue"
          >{{ $tc("add") }}</b-button
        >
      </div>
    </div>

    <div class="d-flex justify-content-between align-items-center my-3">
      <div class="d-flex"></div>
      <div class="d-flex align-items-center">
        <div class="viewing-status">
          <!-- {{ $t("viewing") }}
          <span
            >{{ ticketPriceConfigurationList.length > 0 ? 1 : 0 }}-{{
              ticketPriceConfigurationList.length
            }}</span
          >
          {{ $t("of") }}
          <span>{{ ticketPriceConfigurationList.length }}</span> -->
          <!-- <b-dropdown name="listview" id="listview" variant="outline-blue">
            <template v-slot:button-content>
              {{ $t("viewing") }}
              <span
                >{{ ticketPriceConfigurationList.length > 0 ? 1 : 0 }}-{{
                  ticketPriceConfigurationList.length
                }}</span
              >
              {{ $t("of") }}
              <span>{{ ticketPriceConfigurationList.length }}</span>
            </template>
          </b-dropdown> -->
          <b-dropdown
            v-if="ticketPriceConfigurationList.length > 0"
            name="listview"
            id="listview"
            variant="outline-blue"
          >
            <template v-slot:button-content>
              <!-- {{ $tc("viewing") }}&nbsp;
              <strong>{{ selectedvalue }}</strong>
              &nbsp;Of&nbsp; -->
              <strong>{{ viewingRange }}</strong>
            </template>
            <b-dropdown-item
              v-for="(list, listIndex) in viewingnumbers"
              :key="listIndex"
              @click="onDropDownChangeValue(list.name)"
              >{{ list.name }}</b-dropdown-item
            >
          </b-dropdown>
          <!-- <button class="btn-prev mx-2"></button>
          <button class="btn-next"></button> -->
        </div>
        <!-- <button
          class="btnj btn-gridView mr-3"
          :class="gridView ? 'active':''"
          v-on:click="viewType('gridView')"
        ></button>
        <button
          class="btnj btn-listView"
          :class="listView ? 'active':''"
          v-on:click="viewType('listView')"
        ></button>-->
      </div>
    </div>
    <div class="row shadow bg-white rounded" style="margin: auto">
      <div class="col-md-4 mb-4 mt-4">
        <div>
          <div class>
            <!-- <label>{{ $tc("cinema", 1) }}</label> -->
          </div>
          <div class>
            <b-dropdown
              :text="ticketPriceConfiguration.selectedCinema"
              variant="dropdown-curve"
              class="w-100"
            >
              <!-- _getCountryList(item.label, null) -->
              <b-dropdown-item
                v-for="(dropdownItem, dropdownIndex) in cinemaList"
                :key="dropdownIndex"
                href="#"
                @click="onDropdownChange($event, dropdownItem, 'cinema')"
                >{{ dropdownItem.cine_name }}</b-dropdown-item
              >
            </b-dropdown>
          </div>
        </div>
      </div>

      <div class="col-md-4 mb-4 mt-4">
        <div>
          <div class>
            <!-- <label>{{ $tc("movie") }}</label> -->
          </div>
          <div class>
            <b-dropdown
              :text="ticketPriceConfiguration.selectedMasterMovie"
              variant="dropdown-curve"
              class="w-100"
            >
              <!-- _getCountryList(item.label, null) -->
              <b-dropdown-item
                v-for="(dropdownItem, dropdownIndex) in masterMovies"
                :key="dropdownIndex"
                href="#"
                @click="onDropdownChange($event, dropdownItem, 'movie')"
                >{{ dropdownItem.movie_title }}</b-dropdown-item
              >
            </b-dropdown>
          </div>
        </div>
      </div>
    </div>

    <!-- LIST VIEW DESIGNATION -->
    <table
      class="list-view-table mt-2"
      v-if="listView && ticketPriceConfigurationList.length > 0"
    >
      <thead>
        <tr>
          <th>{{ $tc("action", 1) }}</th>
          <th>{{ $tc("movie", 1) }}</th>
          <th style="width: 200px">{{ $tc("screen", 1) }}</th>
          <th class="text-center" style="width: 200px">
            {{ $tc("Show Start Date") }}
          </th>
          <th class="text-center" style="width: 200px">
            {{ $tc("Show Start Time") }}
          </th>
          <!-- <th>{{ $t('showendtime') }}</th> -->
          <th class="text-left">
            <span class="">{{ $tc("status", 2) }}</span>
          </th>
        </tr>
      </thead>
      <tbody>
        <tr
          v-for="(
            ticketPriceConfiguration, ticketPriceConfigurationIndex
          ) in ticketPriceConfigurationList"
          :key="ticketPriceConfigurationIndex"
        >
          <td>
            <div class="d-flex align-items-center justify-content-start">
              <span
                v-if="ticketPriceConfiguration.s_status_display === 'Active'"
                @click="
                  goToRoute(
                    '/master/edit-ticket-price-configuration',
                    ticketPriceConfiguration
                  )
                "
                class="edit-icon ml-2 cursor-pointer"
                v-b-tooltip="'Edit'"
                tabindex="0"
              >
                <span class="edit-pen blue-icon"></span>
              </span>

              <span
                @click="
                  goToRoute(
                    '/master/view-ticket-price-configuration',
                    ticketPriceConfiguration
                  )
                "
                class="view-icon ml-4 cursor-pointer"
                v-b-tooltip="'View'"
                tabindex="0"
              >
                <span class="icon-eye mr-1 blue-icon"></span>
              </span>
            </div>
          </td>

          <td>{{ ticketPriceConfiguration.movie_title }}</td>
          <td>{{ ticketPriceConfiguration.screen_name }}</td>
          <td class="text-center">
            {{ ticketPriceConfiguration.ss_start_date | dateparse }}
          </td>
          <td class="text-center">
            {{ ticketPriceConfiguration.ss_start_show_time }}
          </td>
          <td>{{ ticketPriceConfiguration.s_status_display }}</td>
          <!-- <td>{{ ticketPriceConfiguration.ss_end_show_time }}</td> -->
          <!-- <td>
            <div class="d-flex align-items-center justify-content-end">
              <b-dropdown right variant="edit" class="ml-4">
                <b-dropdown-item
                  v-if="ticketPriceConfiguration.s_status_display === 'Active'"
                  @click="
                    goToRoute(
                      '/master/edit-ticket-price-configuration',
                      ticketPriceConfiguration
                    )
                  "
                >
                  <span class="edit-pen"></span>
                  {{ $t("edit") }}
                </b-dropdown-item>
                <b-dropdown-item
                  @click="
                    goToRoute(
                      '/master/view-ticket-price-configuration',
                      ticketPriceConfiguration
                    )
                  "
                >
                  <span class="icon-eye mr-1"></span>
                  {{ $t("view") }}
                </b-dropdown-item>
              </b-dropdown>
            </div>
          </td> -->
        </tr>
      </tbody>
    </table>

    <!-- GRID VIEW -->
    <div class="desg-grid-container" v-if="gridView">
      <div
        class="col-md-4 col-lg-4 col-xl-3 px-0"
        v-for="(
          ticketPriceConfiguration, ticketPriceConfigurationIndex
        ) in ticketPriceConfigurationList"
        :key="ticketPriceConfigurationIndex"
      >
        <div class="desg-box">
          <div class="d-flex justify-content-between">
            <h6>{{ ticketPriceConfiguration.movie_title }}</h6>
            <div>
              <b-dropdown right variant="edit">
                <b-dropdown-item
                  @click="
                    goToRoute(
                      '/master/edit-ticket-price-configuration',
                      ticketPriceConfiguration
                    )
                  "
                >
                  <span class="edit-pen mr-1"></span>
                  {{ $t("edit") }}
                </b-dropdown-item>
                <b-dropdown-item
                  @click="
                    goToRoute(
                      '/master/view-ticket-price-configuration',
                      ticketPriceConfiguration
                    )
                  "
                >
                  <span class="icon-eye mr-1"></span>
                  {{ $t("view") }}
                </b-dropdown-item>
              </b-dropdown>
            </div>
          </div>

          <div class="d-flex justify-content-between align-items-end">
            <div class="d-flex align-items-end lh-1">
              <div class="count">
                {{ ticketPriceConfiguration.ss_start_date }}
              </div>
              <div class="text">
                {{ ticketPriceConfiguration.ss_start_show_time }}
                <!-- <br />{{ ticketPriceConfiguration.ss_end_show_time }} -->
                <br />
                {{ ticketPriceConfiguration.s_status_display }}
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="w-full justify-content-center mt-2">
      <b-pagination
        v-model="currentPage"
        :total-rows="rows"
        @change="onChangePagination($event)"
        :per-page="perPage"
        aria-controls="my-table"
      ></b-pagination>
    </div>
  </div>
</template>

<script>
import MasterService from "@/services/MasterService";
import MovieService from "@/services/MovieService";
import CinemasService from "@/services/CinemasService";

export default {
  data() {
    return {
      // Saif
      cinemaList: [],
      masterMovies: [],
      ticketPriceConfigurationList: [],
      ticketPriceConfiguration: {
        movie_id: null,
        selectedMasterMovie: "Select Movie",
        cine_id: null,
        selectedCinema: "Select Cinema",
      },
      // Saif
      gridView: false,
      viewingnumbers: [],
      listView: true,
      perPage: 10,
      currentPage: 1,
      rows: 0,
      selectedvalue: "10",
    };
  },
  computed: {
    viewingRange() {
      if (this.rows === 0) {
        return "Viewing 0 to 0 of 0";
      }

      const start = (this.currentPage - 1) * this.perPage + 1;
      const end = Math.min(this.currentPage * this.perPage, this.rows);

      return `Viewing ${start} to ${end} of ${this.rows}`;
    },
  },
  beforeMount() {
    this.getviewingnumber();
    this.getCinemaList();
    this.getActiveMasterMoviesList();
  },
  mounted() {},
  methods: {
    /* eslint-disable */
    // Saif
    getviewingnumber() {
      this.viewingnumbers = [
        { name: "All", id: 1 },
        { name: "10", id: 2 },
        { name: "20", id: 3 },
        { name: "30", id: 3 },
        { name: "40", id: 4 },
        { name: "50", id: 5 },
      ];
    },
    onDropDownChangeValue(event) {
      if (event == "All") {
        this.perPage = this.rows;
        this.selectedvalue = event;
        this.onChangePagination();
      } else {
        console.log("Numbers :", event);
        this.selectedvalue = event;
        this.perPage = event;
        console.log("perPage :", this.perPage);
        this.onChangePagination();
      }
      if (!this.masterMovies) {
        this.getActiveMasterMoviesList();
      }
    },
    onChangePagination: function (event) {
      // console.log(event);
      if (event === undefined) {
        this.currentPage = 1;
        this.getTicketPriceConfigurationList();
      } else {
        this.currentPage = event;
        this.getTicketPriceConfigurationList();
      }
    },

    getCinemaList: function () {
      let body = this.getRequestBody("GET", undefined, {
        GET: "/admin/",
        tableName: "ms_cinemas",
      });
      MasterService.GlobalRequest(body)
        .then((response) => {
          const { data } = response;
          if (data.status && data.Records.length > 0) {
            this.cinemaList = data.Records;
          } else {
            // Show Error Message:
            console.log("data.message :", data.message);
          }
        })
        .catch((error) => {
          console.log("Catch Error On getCinemaList :", error);
        });
    },
    getActiveMasterMoviesList: function () {
      MovieService.GetActiveMasterMovies()
        .then((response) => {
          const { data } = response;
          if (data && data.status && data.Records.length > 0) {
            this.masterMovies = data.Records;
          } else {
            // Show Error Message:
            console.log("data.message :", data.message);
          }
        })
        .catch((error) => {
          console.log("Catch Error on getActiveMasterMoviesList :", error);
        });
    },
    getTicketPriceConfigurationList: function () {
      if (
        this.ticketPriceConfiguration.movie_id &&
        this.ticketPriceConfiguration.cine_id
      ) {
        let payload = {
          cine_id: this.ticketPriceConfiguration.cine_id,
          movie_id: this.ticketPriceConfiguration.movie_id,
          screen_id: null,
          ss_start_date: null,
          ss_end_date: null,
          limit: this.perPage,
          currentPage: this.currentPage,
        };

        CinemasService.GetTicketPriceConfiguration(payload)
          .then((response) => {
            const { data } = response;
            if (data && data.status && data.Records.length > 0) {
              this.ticketPriceConfigurationList = data.Records;
              if (data.totalRows >= 10) {
                this.rows = data.totalRows;
              } else {
                this.rows = data.totalRows;
                this.selectedvalue = data.totalRows;
              }
            } else {
              // Show Error Message:
              console.log("data.message :", data.message);
            }
          })
          .catch((error) => {
            // Catch Error:
            console.log(
              "Catch Error on getTicketPriceConfigurationList :",
              error
            );
          });
      }
    },
    goToRoute: function (path, item) {
      const { md_id, ss_id } = item;
      this.$router.push({
        path: path,
        query: {
          md_id,
          ss_id,
        },
      });
    },
    onDropdownChange: function (event, item, dropdown) {
      if (dropdown === "cinema") {
        this.ticketPriceConfiguration.selectedCinema = item.cine_name;
        this.ticketPriceConfiguration.cine_id = item.cine_id;
      } else if (dropdown === "movie") {
        this.ticketPriceConfiguration.selectedMasterMovie = item.movie_title;
        this.ticketPriceConfiguration.movie_id = item.movie_id;
      }
      this.getTicketPriceConfigurationList();
    },

    // Saif

    viewType: function (viewType) {
      if (viewType == "gridView") {
        this.gridView = true;
        this.listView = false;
      } else if ((viewType = "listView")) {
        this.listView = true;
        this.gridView = false;
      }
    },
    // onClickEdit: function(){
    //   this.$router.push({ path: 'master/editaggregators' })
    // }
  },
};
</script>



// WEBPACK FOOTER //
// src/components/Pages/CinemaContainer/TicketPriceConfigurationComponents/ticketPriceConfiguration.vue